import { render, staticRenderFns } from "./BasalamAttribute.vue?vue&type=template&id=2ae600f6&scoped=true"
import script from "./BasalamAttribute.vue?vue&type=script&lang=js"
export * from "./BasalamAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae600f6",
  null
  
)

export default component.exports